const initialState = {
  idUsuario: null,
  email: null,
  fullName: null,
  token: null,
  jwt: null,
  ambientes: null,
  idPerfil: null,
  logo: null,
  marcaOrigen: null,
  modo: null,
  paletaColor: null,
  perfil: null,
  idMarcaOrigen: null,
  modules: null,
  logoFinal: null,
  imagen: null,
  idTipoOperOrigen: null,
  tipoOperOrigen: null,
  ambiente: null,
};

export default function userReducer(state = initialState, action: any) {
  switch (action.type) {
    case "LOG_IN":
      const { token, jwt, modules } = action.payload;

      let add = action.payload.additional;

      return {
        ...state,
        idUsuario: add.idUsuario,
        email: add.correo,
        fullName: add.nombre,
        ambientes: null,
        token,
        jwt,
        modules,
        ambiente: add.ambiente ? add.ambiente : null,
      };
    case "SET_JWT":
      const { payload } = action;
      //@ts-ignore
      const { additional } = payload;
      return {
        ...state,
        jwt: payload.jwt,
        idPerfil: additional.idPerfil,
        logo: additional.logo,
        marcaOrigen: additional.marcaOrigen,
        modo: additional.modo ? additional.modo : "claro",
        paletaColor: additional.paletaColor,
        perfil: additional.perfil,
        idMarcaOrigen: additional.idMarcaOrigen,
        modules: payload.modules,
        logoFinal: additional.logoFinal,
        imagen: additional.imagen,
        idTipoOperOrigen: additional.idTipoOperOrigen,
        tipoOperOrigen: additional.tipoOperOrigen,
      };
    case "LOAD_USER":
      return Object.assign({}, state, {
        name: action.user.name,
        _id: action.user._id,
        email: action.user.email,
      });
    case "SET_THEME_MODO":
      return {
        ...state,
        modo: action.modo ? action.modo : "claro",
      };
    case "SET_IMAGEN":
      return {
        ...state,
        imagen: action.payload,
      };
    case "SET_AMB":
      return {
        ...state,
        ambiente: action.payload,
      };
    case "LOGOUT":
      return { ...initialState };
    default:
      return state;
  }
}
